import { render, staticRenderFns } from "./VisualAudioDisplay.vue?vue&type=template&id=b22ba37c"
import script from "./VisualAudioDisplay.vue?vue&type=script&lang=js"
export * from "./VisualAudioDisplay.vue?vue&type=script&lang=js"
import style0 from "./VisualAudioDisplay.vue?vue&type=style&index=0&id=b22ba37c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports